import styled from 'styled-components';
import { colors, BREAKPOINTS } from 'common/styles/style-constants';
import { Modal } from 'opencare-crown';

import { StyledInput } from '../../../legacy-checkout/checkout-styled-components';

export const StyledModal = styled(Modal)`
  && {
    &.ant-modal {
      display: flex;
      justify-content: center;
      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        height: 100vh;
        margin: 0;
        max-width: 100vw;
        top: 0;
        width: 100vw !important;
      }
    }
    .ant-modal-content {
      padding: 50px 15px;
      width: 330px;
      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        border-radius: 0;
        height: 100vh;
        width: 100vw;
      }
    }
  }
`;

export const StyledRedInput = styled(StyledInput)`
  && {
    border: 1px solid ${colors.danger};
  }
`;
